import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { CalendarClock } from "lucide-react";

const parseDate = (dateStr) => {
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const UpcomingEventsBanner = ({ refreshKey }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    api
      .get("/admin/events")
      .then((r) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const in7Days = new Date(today);
        in7Days.setDate(in7Days.getDate() + 7);
        const upcoming = r.data.filter((e) => {
          const d = parseDate(e.date);
          return d >= today && d <= in7Days;
        });
        setCount(upcoming.length);
      })
      .catch(() => {});
  }, [refreshKey]);

  if (count === 0) return null;

  return (
    <div
      data-testid="upcoming-events-banner"
      className="bg-twp-gold/10 border-b border-twp-gold/30 px-6 py-2.5 flex items-center gap-2 text-sm text-neutral-800"
    >
      <CalendarClock size={16} className="text-twp-goldmuted" />
      Tienes{" "}
      <span data-testid="upcoming-events-count" className="font-semibold text-twp-goldmuted">
        {count}
      </span>{" "}
      {count === 1 ? "evento" : "eventos"} en los próximos 7 días.
    </div>
  );
};
